var map = {
	"./at/de/engagementRings_FAQPage.json": 2123,
	"./at/de/engagementRings_WebPage.json": 2124,
	"./at/de/weddingRings_FAQPage.json": 2125,
	"./at/de/weddingRings_WebPage.json": 2126,
	"./at/en/engagementRings_FAQPage.json": 2127,
	"./at/en/weddingRings_FAQPage.json": 2128,
	"./ch/de/engagementRings_FAQPage.json": 2129,
	"./ch/de/engagementRings_WebPage.json": 2130,
	"./ch/de/weddingRings_FAQPage.json": 2131,
	"./ch/de/weddingRings_WebPage.json": 2132,
	"./ch/en/engagementRings_FAQPage.json": 2133,
	"./ch/en/weddingRings_FAQPage.json": 2134,
	"./ch/fr/engagementRings_FAQPage.json": 2135,
	"./ch/fr/weddingRings_FAQPage.json": 2136,
	"./de/de/engagementRings_FAQPage.json": 2137,
	"./de/de/engagementRings_WebPage.json": 2138,
	"./de/de/index_Organization.json": 2139,
	"./de/de/shopsDetails_berlin.json": 2140,
	"./de/de/weddingRings_FAQPage.json": 2141,
	"./de/de/weddingRings_WebPage.json": 2142,
	"./de/en/engagementRings_FAQPage.json": 2143,
	"./de/en/weddingRings_FAQPage.json": 2144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2122;